export default {
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  'default': '服务器内部错误',
  // '500': '网络连接失败，请稍后再试',
}
// request.js中使用提示错误信息
